<template>
    <index-table
        :cols="[
            {
                value: 'name',
                label: 'Name',
                searchable: true,
                sortable: true,
            },
            {
                value: 'roles',
                label: 'Roles',
                display: 'name',
                searchable: false,
                sortable: false,
            },
        ]"
        :title="'Permissions'"
        :model="'permissions'"
        :createText="'Create Permission'"
        :options="['editable', 'deletable']"
        data-test-id="permissions-table"
    />
</template>

<script>
import IndexTable from '@/components/IndexTable/index.vue'

export default {
    components: {
        IndexTable,
    },
}
</script>
